import type { ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

export const LogoMark = ({ className }: { className?: string }): ReactNode => {
    return (
        <svg viewBox='0 0 32 32' aria-hidden='true' className={cn('shrink-0', className)}>
            <rect width='32' height='32' rx='8' fill='#f0b429' />
            <path
                d='M5.5 22.5L11.5 14.8L15.1 18.9L20.8 9L26.5 22.5'
                fill='none'
                stroke='#14100a'
                strokeWidth='2.6'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path d='M18.6 12.9L20.8 9L23 12.9' fill='none' stroke='#fff7e0' strokeWidth='1.4' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    )
}

export const Logo = ({ className }: { className?: string }): ReactNode => {
    return (
        <Link href='/' aria-label='Kilele Exchange home' className={cn('flex items-center gap-2.5 rounded-md', className)}>
            <LogoMark className='size-8' />
            <span className='font-heading text-[15px] font-semibold leading-none tracking-tight text-foreground'>
                Kilele
                <span className='font-normal text-muted-foreground'> Exchange</span>
            </span>
        </Link>
    )
}
